var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4591 12.8004L13.4589 12.8006C12.8809 13.3566 12.207 13.7931 11.4553 14.0989C9.90079 14.7307 8.09896 14.7307 6.54488 14.0989L6.54486 14.0989C5.79359 13.7935 5.11978 13.3567 4.54104 12.8005L4.54093 12.8004C3.96188 12.2448 3.50843 11.5981 3.19171 10.8786L3.1917 10.8786C2.86412 10.1348 2.69801 9.34415 2.69801 8.52825C2.69801 7.71193 2.86412 6.92126 3.19169 6.17708C3.50821 5.45845 3.96166 4.81172 4.54088 4.2561L4.54106 4.25593C5.11978 3.69942 5.79352 3.26258 6.54475 2.95765L6.5449 2.95759C8.09684 2.32622 9.90294 2.32621 11.4553 2.9576L11.4554 2.95763C12.2069 3.263 12.8809 3.69986 13.4589 4.25591L13.4593 4.25627C13.6115 4.40193 13.7579 4.55754 13.8954 4.72004H11.7068C11.4664 4.72004 11.2582 4.90959 11.2582 5.15935C11.2582 5.40828 11.4664 5.59826 11.7068 5.59826H14.9512C15.1912 5.59826 15.4002 5.40873 15.4002 5.15935V2.04246C15.4002 1.7927 15.1916 1.60273 14.9512 1.60273C14.7105 1.60273 14.5022 1.7928 14.5022 2.04246V4.06155C13.1284 2.49703 11.1291 1.60273 9 1.60273C5.03743 1.60273 1.8 4.70194 1.8 8.52825C1.8 12.3546 5.03743 15.4538 9 15.4538C12.9626 15.4538 16.2 12.3546 16.2 8.52825C16.2 8.27828 15.9914 8.08895 15.7512 8.08895C15.5112 8.08895 15.302 8.27795 15.302 8.52825C15.302 9.34415 15.1359 10.1348 14.8083 10.879C14.4916 11.5981 14.0381 12.2448 13.4591 12.8004Z",
    fill: "#286248",
    stroke: "#286248",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirth);
export default __webpack_public_path__ + "static/media/Girth.9b88b5e177c082d5f3b8f4c7cc43a890.svg";
export { ForwardRef as ReactComponent };